import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  const params = new URLSearchParams({ agency_id: agencyId });
  return params.toString();
}

export async function runFundingMatches(clientId, agencyId) {
  const data = await fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/matches/run?${agencyQuery(agencyId)}`,
    { method: 'POST' },
  );
  return {
    matches: data.matches ?? [],
    total: data.total ?? (data.matches?.length ?? 0),
  };
}

export async function fetchFundingMatches(clientId, agencyId, filters = {}) {
  const params = new URLSearchParams({ agency_id: agencyId });
  if (filters.fitTier) params.set('fit_tier', filters.fitTier);
  if (filters.lenderType) params.set('type', filters.lenderType);
  if (filters.productType) params.set('product_type', filters.productType);

  const data = await fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/matches?${params.toString()}`,
  );
  return {
    matches: data.matches ?? [],
    total: data.total ?? (data.matches?.length ?? 0),
  };
}

export async function fetchFundingMatchesList({ agencyId, limit = 50 } = {}) {
  const params = new URLSearchParams();
  if (agencyId) params.set('agency_id', agencyId);
  if (limit) params.set('limit', String(limit));
  const query = params.toString();
  const data = await fundingHqFetch(`/matches${query ? `?${query}` : ''}`);
  return {
    matches: data.matches ?? [],
    total: data.total ?? (data.matches?.length ?? 0),
  };
}

export async function fetchFundingLenders(filters = {}) {
  const params = new URLSearchParams();
  if (filters.lenderType) params.set('type', filters.lenderType);
  if (filters.productType) params.set('product_type', filters.productType);
  if (filters.state) params.set('state', filters.state);
  if (filters.search) params.set('search', filters.search);
  if (filters.acceptsLowCredit != null) params.set('accepts_low_credit', String(filters.acceptsLowCredit));
  if (filters.acceptsStartups != null) params.set('accepts_startups', String(filters.acceptsStartups));
  if (filters.commissionAvailable != null) params.set('commission_available', String(filters.commissionAvailable));

  const query = params.toString();
  const data = await fundingHqFetch(`/lenders${query ? `?${query}` : ''}`);
  return {
    lenders: data.lenders ?? [],
    total: data.total ?? (data.lenders?.length ?? 0),
  };
}
